import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import Loader from './../../components/Loader/Loader'
import Intro from '../../components/FeedingGuidelines/Intro/Intro';
import fetchFeedingGuidelinesIntroAction from './../../store/actions/fetch/fetchFeedingGuidelinesIntroAction';
import * as actionTypes from './../../store/actions/feedingGuidelinesIntroAction';
import * as moment from 'moment';
import * as pdfOutputAction from './../../store/actions/pdfOutputAction';
import domtoimage from 'dom-to-image';
import OnImagesLoaded from 'react-on-images-loaded';
import {getAgeString} from '../../helpers/DateHelper';


class FeedingGuidelinesIntro extends Component {

  componentDidMount() {
    const {fetchData, state} = this.props;
    fetchData(state);
  }

  doScreenShot() {
    const {screenshots}  = this.props;
    const el = document.getElementById('fc-screenshot-feeding-guidelines-intro');
    const {setScreenShot, onScreenshotError} = this.props;
    if (el){
      domtoimage.toPng(el)
        .then(function (dataUrl) {
          if (screenshots && screenshots['fc-screenshot-feeding-guidelines-intro'] !== dataUrl){
            setScreenShot(dataUrl);
          }
        })
        .catch(function () {
          onScreenshotError();
        });
    } else {
      onScreenshotError();
    }
  }

  render() {
    const {output} = this.props;

    const {data, pending, ready, error, casuistic, state, mealsPerDay, petData, feedingAmounts} = this.props;

    if(pending || !ready) return (
      <Loader/>
    );

    return (
      <OnImagesLoaded
        onLoaded={this.doScreenShot.bind(this)}
        onTimeout={this.doScreenShot.bind(this)}
        timeout={7000}>
        <Intro
          data={data}
          petData={petData}
          output={output}
          casuistic={casuistic}
          state={state}
          mealsPerDay={mealsPerDay}
          feedingAmounts={feedingAmounts}
        />
      </OnImagesLoaded>
    );
  }
}

const getReproductiveStatusString = (state) => {
  let data = [];
  if (state.signalmentReducer.selectedLactation) data.push(state.signalmentReducer.data.data.lactation);
  if (state.signalmentReducer.selectedPregnant) data.push(state.signalmentReducer.data.data.pregnant);
  if (state.signalmentReducer.selectedSterilised) data.push(state.signalmentReducer.data.data.sterilised);
  if (data.length === 0) data.push(state.signalmentReducer.data.data.default);
  return data.join(", ");
}

const mapStateToProps = state => {
  const reproductiveStatusString = getReproductiveStatusString(state);

  // Get the displayed age string
  const dictionary = {
    day: state.birthDateReducer.data.output.day,
    days: state.birthDateReducer.data.output.days,
    monthDay: state.birthDateReducer.data.output.monthDay,
    monthDays: state.birthDateReducer.data.output.monthDays,
    monthsDay: state.birthDateReducer.data.output.monthsDay,
    monthsDays: state.birthDateReducer.data.output.monthsDays,
    month: state.birthDateReducer.data.output.month,
    months: state.birthDateReducer.data.output.months,
    yearMonth: state.birthDateReducer.data.output.yearMonth,
    yearMonths: state.birthDateReducer.data.output.yearMonths,
    yearsMonth: state.birthDateReducer.data.output.yearsMonth,
    yearsMonths: state.birthDateReducer.data.output.yearsMonths,
    year: state.birthDateReducer.data.output.year,
    years: state.birthDateReducer.data.output.years,
  }

  const birthDate = moment(state.birthDateReducer.selected);
  const todayDate = moment();
  const diffDuration = moment.duration(todayDate.diff(birthDate));
  const difference = {
    years: diffDuration.years(),
    months: diffDuration.months(),
    days: diffDuration.days(),
  }

  const ageString = getAgeString(difference, dictionary);

  return {
    data: state.feedingGuidelinesIntroReducer.data,
    pending: state.feedingGuidelinesIntroReducer.pending,
    ready: state.feedingGuidelinesIntroReducer.ready,
    error: state.feedingGuidelinesIntroReducer.error,
    screenshots: state.pdfOutputReducer.images,
    state: state,
    casuistic: state.calculateDerReducer.data.casuistic,
    mealsPerDay: state.petInfoReducer.mealsPerDay,
    petData: {
      age: ageString,
      gender: state.genderReducer.selected,
      genderLabelTerm: state.genderReducer.data.data[state.genderReducer.selected],
      reproductiveStatus: reproductiveStatusString,
      breedSize: state.breedReducer.selectedData.label,
    },
    feedingAmounts: state.dailyWetReducer.amounts,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: (e) => {
      dispatch (fetchFeedingGuidelinesIntroAction(e));
    },
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
    setScreenShot: (data) => dispatch({
      type: pdfOutputAction.ADD,
      key: 'fc-screenshot-feeding-guidelines-intro',
      data: data,
    }),
    onScreenshotError: () => dispatch({
      type: pdfOutputAction.SCREENSHOT_ERROR,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedingGuidelinesIntro);
